import DataTableView from "@components/views/datatable-view";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import Upsert from "./upsert";
import usePeople from "./use-people";

const People = () => {
    const {
        loading,
        data,
        columns,
        modalConfig,
        handleModal,
        getPeoples
    } = usePeople();

    return (
        <>
            <DataTableView
                className="mt-2"
                moduleName="People"
                tableProps={{
                    enableSelect: true,
                    data,
                    columns
                }}
                actionItems={
                    <Flex align="center">
                        <LoadingButton
                            color="primary"
                            icon="plus"
                            text="Add People"
                            onClick={() => handleModal()}
                            className="details-page-add-button"/>
                    </Flex>
                }
                loading={loading}/>
            
            <Upsert modalConfig={modalConfig} handleModal={handleModal} getPeoples={getPeoples} />
        </>
    );
};

export default  People;